import { IKnmAbrogationReason } from 'APIPackage/CatalogsModule/interfaces/IKnmAbrogationReason';

export const createKnmAbrogationReasonSelectOption = (knmType: IKnmAbrogationReason) => ({
  ...knmType,
  label: knmType.name,
  value: knmType.code,
});
